<script>
  import SyncDashboard from "../components/syncDashboard/syncDashboard.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  export const location = undefined;
  export const navigate = undefined;
</script>

<div class="min-h-screen bg-[#1b1e2f] text-white">
  <PageContainer fullWidth={true} className="px-4 py-5 sm:px-6 lg:px-8">
    <SyncDashboard />
  </PageContainer>
</div>
